module.exports = __webpack_public_path__ + "img/cta-banner-1.5875e55f.png";